import { 
    apiBizGetPersonalInfo,
    apiSetUserShot,
    baseDomain
} from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_personal_info: 'personalCenter/set_personal_info',
}

// count state 必須是 Object
const state = {
    personalInfo: null,
    update: 0
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    BIZ_GET_PERSONAL_INFO: (state) => {
        return state.personalInfo
    },
    BIZ_GET_PERSONAL_SHOT: (state) => {
        if(state.personalInfo && state.personalInfo.filePath){
            return baseDomain+state.personalInfo.filePath
        }else{
            return null
        }
    }
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizPersonalInfo ( {commit, dispatch} ) {
        return new Promise((resolve, reject) => {
            apiBizGetPersonalInfo()
            .then(res => {
                console.log(res)
                if(res.data.status == "SUCCESS"){
                    commit(types.set_personal_info, res.data.result)
                    resolve(res)
                }
                // commit(types.auth_success, token)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizUserShot ( {commit, dispatch}, files) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            console.log(files)
            formData.append('file', files[0].file);

            apiSetUserShot(formData)
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    location.reload();
                }
            })
        })
    },
}

// mutations
const mutations = {
    [types.set_personal_info](state, data){
        state.personalInfo = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/personalCenter/personalCenter.js